interface ChecklistItem { id: string; label: string; done: boolean; action?: React.ReactNode; }
interface ChecklistProps { items: ChecklistItem[]; }

export const allDone = (items: ChecklistItem[]) => items.every(i => i.done);

export function Checklist({ items }: ChecklistProps) {
  return (
    <ul className="chk">
      {items.map(i => (
        <li key={i.id} className={`chk-item${i.done ? ' done' : ''}`}>
          <span className="chk-mark" aria-hidden>{i.done ? '✓' : '○'}</span>
          <span className="chk-label">{i.label}</span>
          {i.action && <span className="chk-action">{i.action}</span>}
        </li>
      ))}
    </ul>
  );
}
